import { claimRecoveryAttempt } from "./loadingRecovery";
import { lazy, type ComponentType } from "react";

const RELOAD_FLAG = "gps_chunk_reload_attempted";

/**
 * Drop-in replacement for React.lazy(). A tab left open across a deploy
 * keeps running the old bundle in memory; when it later lazy-imports a route
 * chunk, the browser requests the hashed filename baked into that old
 * bundle — a file Vercel no longer serves once a newer deploy replaced it.
 * That import() rejects with "Failed to fetch dynamically imported module",
 * which normally lands on AppErrorBoundary's generic screen with no way
 * forward except knowing to manually refresh.
 *
 * Reloading the page fetches the current index.html and current bundle,
 * which reference the CURRENT chunk hashes — one reload always resolves
 * this class of error. The sessionStorage flag caps it at one automatic
 * reload per tab session so a genuinely broken deploy doesn't reload-loop.
 */
export function lazyWithReload<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(() =>
    factory().catch((error: unknown) => {
      if (claimRecoveryAttempt(RELOAD_FLAG)) {
        window.location.reload();
        // The reload takes over before this promise would need to settle.
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    })
  );
}
